<div 
  [ngStyle]="{
    'font-size': fontSize || 'auto'
  }"
  class="c-badge" [ngSwitch]="status"
>
  <span class="badge text-bg-pendiente shade" *ngSwitchCase="exceptionStatus.pending"><span i18n>Solicitada</span> <i class="bi bi-clock"></i></span>
  <span class="badge text-bg-pendiente shade" *ngSwitchCase="exceptionStatus.attention"><span i18n>Información requerida</span> <i class="bi bi-clock"></i></span>
  <span class="badge text-bg-validating shade" *ngSwitchCase="exceptionStatus.validating"><span i18n>Verificando consultas</span> <i class="bi bi-clock"></i></span>
  <span class="badge text-bg-validation shade" *ngSwitchCase="exceptionStatus.validated"><span i18n>Consultas ejecutadas</span> <i class="bi bi-clock"></i></span>
  <span class="badge text-bg-activo shade" *ngSwitchCase="exceptionStatus.revision"><span i18n>Revisión</span> <i class="bi bi-clock"></i></span>
  <span class="badge text-bg-pendiente shade" *ngSwitchCase="exceptionStatus.revisionN2">
    <span i18n *ngIf="!simple">Revisión N2</span>
    <span i18n *ngIf="simple">Revisión</span>
    <i class="bi bi-clock"></i>
  </span>
  <span class="badge text-bg-pendiente shade" *ngSwitchCase="exceptionStatus.pre_accepted">
    <span i18n *ngIf="!simple">Pre-Aceptada</span>
    <span i18n *ngIf="simple">Revisión</span>
    <i class="bi bi-check"></i>
  </span>
  <span class="badge text-bg-aceptado shade" *ngSwitchCase="exceptionStatus.accepted"><span i18n>Aceptada</span> <i class="bi bi-check"></i></span>
  <span class="badge text-bg-pendiente shade" *ngSwitchCase="exceptionStatus.pre_rejected">
    <span i18n *ngIf="!simple">Pre-Rechazada</span>
    <span i18n *ngIf="simple">Revisión</span>
    <i class="bi bi-x"></i>
  </span>
  <span class="badge text-bg-rechazado shade" *ngSwitchCase="exceptionStatus.rejected"><span i18n>Rechazada</span> <i class="bi bi-x"></i></span>
  <span class="badge text-bg-cancelado shade" *ngSwitchCase="exceptionStatus.expired"><span i18n>Caducada</span> <i class="bi bi-x"></i></span>
</div>